/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ChatDeniedReconnectMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ChatDeniedReconnectMessageHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_CHAT_DENIED_RECONNECT);
};

$hxClasses.extend(
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler,
	com.inq.flash.client.control.messagehandlers.ChatDeniedReconnectMessageHandler,
	"com.inq.flash.client.control.messagehandlers.ChatDeniedReconnectMessageHandler"
);

/**
 * It processes the incoming chat.denied.reconnect message
 * and closes the chat due to its closing on the server side.
 *
 * @override
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ChatDeniedReconnectMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatDeniedReconnectMessageHandler.prototype.processMessage = function(message) {
	this.getController().onLostConnection();
};

/** @type {com.inq.flash.client.control.messagehandlers.ChatDeniedReconnectMessageHandler} */
com.inq.flash.client.control.messagehandlers.ChatDeniedReconnectMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ChatDeniedReconnectMessageHandler;
